App.AdminTable = class extends App.DataTable {
  constructor(table) {
    const dataSourceUrl = '/organizations/data_table';

    const columns = [
      { data: "member_number" },
      {
        data: "name",
        render: function ( data, type, full, meta ) {
          if(full.canEditOrgs) {
            var last_synced_at = Date.parse(full.last_synced_at);
            last_synced_at     = isNaN(last_synced_at) ? '' : new Date(full.last_synced_at).toLocaleDateString("en-US");
            var orgLink        = "/organizations/" + full.id;
            return '<a href="' + orgLink + '">' + full.name + '</a><span class="last-synced-at">Synced ' + last_synced_at + '</span>';
          } else {
            return full.name;
          }
        }
      },
      { data: 'status', name: 'status' },
      { data: "member_type" },
      { data: "coverages", sortable: false },
      {
        title: '',
        sortable: false,
        render: function ( data, type, full, meta ) {
          if(full.canSeeUsers) {
            var usersLink = "/organizations/" + full.id + "/set_current?redirect_url=/users";
            return '<a href="' + usersLink + '" class="btn btn-xxs btn-brand-yellow">Users</a>';
          } else {
            return "<p>Your account lacks permission to edit the members of this organization.</p>";
          }
        }
      },
      {
        title: '',
        sortable: false,
        render: function ( data, type, full, meta ) {
          if(full.canSeeRoles) {
            var rolesLink = "/organizations/" + full.id + "/set_current?redirect_url=/organizations/" + full.id + "/roles";
            return '<a href="' + rolesLink + '" class="btn btn-xxs btn-brand-yellow">Roles</a>';
          } else {
            return "<p>Your account lacks permission to edit the Roles &amp; Permissions of this organization.</p>";
          }
        }
      },
      {
        title: '',
        sortable: false,
        render: function ( data, type, full, meta ) {
          if(full.canSeeReports) {
            var reportsLink = "/organizations/" + full.id + "/set_current?redirect_url=/reports";
            return '<a href="' + reportsLink + '" class="btn btn-xxs btn-brand-yellow">Reports</a>';
          } else {
            return "<p>Your account lacks permission to view monthly reports.</p>";
          }
        }
      },
      {
        title: '',
        sortable: false,
        render: function ( data, type, full, meta ) {
          if(full.canAnswerRmgSurvey) {
            var rmgLink = "/rmg";
            return '<a href="' + rmgLink + '" class="btn btn-xxs btn-brand-yellow">RMG</a>';
          } else if(full.canSeeRmgSurvey) {
            var rmgLink = "/organizations/" + full.id + "/rmg";
            return '<a href="' + rmgLink + '" class="btn btn-xxs btn-brand-yellow">RMG</a>';
          } else {
            return "";
          }
        }
      }
    ];

    var searchFilterHtml = {
      'filter-active': "<select class='form-control input-sm'><option value=''>Any</option><option selected='selected'>Active</option><option>Inactive</option>"
    };

    super({ table: table, dataSourceUrl: dataSourceUrl, columns: columns, noData: null, pageLength: 10, searchFilterHtml: searchFilterHtml });
  }

  /**
   * Initialize the datatable to only display the organizations with a Status column of "Active"
   */
  setupInitialTable() {
    $("#admin_table").DataTable().column('status:name').search('Active').draw();
  }

}

$(document).on('turbo:load', function() {
  if($(".member.administration").length == 0) return;
  var adminTable = new App.AdminTable($("#admin_table"));
  adminTable.render();
  adminTable.setupInitialTable();
});
